// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import router from "./router";
import app from "./app.vue";
import "./assets/styles.scss";
import "./assets/transitions.scss";
import VeeValidate from "vee-validate";
import config from "./lib/config";
import store from "./store";

Vue.use(VeeValidate, { classes: true });

function loadScript(url, callback) {
  // adding the script tag to the head as suggested before
  var head = document.getElementsByTagName("head")[0];
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;

  // then bind the event to the callback function
  // there are several events for cross browser compatibility
  script.onreadystatechange = callback;
  script.onload = callback;

  // fire the loading
  head.appendChild(script);
}
loadScript(config.flinkLibraryUrl, () => {
  console.log("loading", config.flinkLibraryUrl);
  flink.config.baseUrl = config.apiBaseUrl;
  app.store = store();

  /* eslint-disable no-new */
  new Vue({
    el: "#app",
    router,
    template: "<app/>",
    components: { app }
  });
});

Vue.config.productionTip = false;



// WEBPACK FOOTER //
// ./src/main.js